import { Route, Redirect } from "react-router-dom";
import React, { Fragment } from "react";
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import Login from "../../Components/Login";
import Agents from "../../Components/Agents";
import Conversations from "../../Components/Conversations";
import Goal from "../../Components/Analysis/Goal";
import ABTest from "../../Components/CallAnalysis/ABTest";
import LostCall from "../../Components/Analysis/LostCall";
import PhoneNumber from "../../Components/Settings/PhoneNumber";
import Users from "../../Components/Settings/Users";
import General from "../../Components/Agency/General";
import Subaccounts from "../../Components/Agency/Subaccounts";
import CustomDomain from "../../Components/Agency/CustomDomain";
import Profile from "../../Components/Profile";
import SiteLogin from "../../Site/Login/index";
import ResetPassword from "../../Site/ForgotPassword/resetpassword";
import ForgotPassword from "../../Site/ForgotPassword/index";
// import PricingList from "../../Components/Agency/PricingList";
import Payment from "../../Components/Agency/Payment";
import InviteForm from "../../Site/Signup";
import Contacts from "../../Components/Contacts/Contacts";
import ContactsLists from "../../Components/Contacts/List";
import Tags from "../../Components/Contacts/Tags";
import ContextControl from "../../Context/AllGeneral";
import ActivateSignup from "../../Site/Signup/ActivateSignup";
import MainDashboard from "../../Components/MainDashboard";
import OutboundService from "../../Components/Outbound";
import OutboundOperations from "../../Components/Outbound/Operations";
import CallVolume from "../../Components/CallAnalysis/CallVolume";
import CallDuration from "../../Components/CallAnalysis/CallDuration";
import CallOutcome from "../../Components/CallAnalysis/CallOutcome";
import CallHeatmap from "../../Components/CallAnalysis/CallHeatmap";
import Webhooks from "../../Components/Webhooks";
import ImportExport from "../../Components/Contacts/ImportExport";
import CustomFields from "../../Components/Contacts/CustomFields";
import UsageMain from "../../Components/Usage";
// import GoogleCalendar from "../../Components/Integrations/GoogleCalendar";
import Integrations from "../../Components/Integrations";
import CallBack from "../../Components/Integrations/Callback";
// import ProfitReport from "../../Components/ProfitReport";
import AllSubPaymentHistory from "../../Components/Agency/AllSubPaymentHistory";

import ProfitReport from "../../Components/ProfitReport";
import Tools from "../../Components/Settings/Tools";
import EmailTemplates from "../../Components/Agency/EmailTemplates"
import WhiteLabel from "../../Components/Agency/WhiteLabel";
import KnowledgeBase from "../../Components/KnowledgeBase/KnowledgeBase";
// import Logs from "../../Components/Logs";
// import PaymentCallBack from "../../Components/Subscription/PaymentCallBack";
import Onboarding from "../../Site/Login/Onboarding";
import PaymentCallBack from "../../Components/Subscription/PaymentCallBack";
import Logs from "../../Components/Logs";
import Widgets from "../../Components/Widgets";
import Notifications from "../../Components/Notifications";
import WebsiteWidget from "../../Components/Widgets/WebsiteWidget";
import AIPromptLibrary from "../../Components/Agency/AiPromptLibrary";
import WidgetProvider from "../../Components/Widgets/WidgetProvider";

const AppMain = () => {

    return (
        <Fragment>
            <Route path="/brand/:subMenu" component={WhiteLabel} />
            <Route path="/login_check" component={Login}/>
            <Route path="/overview" component={MainDashboard}/>
            <Route path="/agents" component={Agents}/>
            <Route path="/call-history" component={Conversations}/>
            <Route path="/goals" component={Goal}/>
            <Route path="/abtesting" component={ABTest}/>
            <Route path="/lostcalls" component={LostCall}/>
            <Route path="/numbers" component={PhoneNumber}/>
            <Route path="/users" component={Users}/>
            <Route path="/general" component={General}/>
            <Route path="/clients" component={Subaccounts}/>
            <Route path="/custom_domain" component={CustomDomain}/>
            <Route path="/subscription-tiers" component={ContextControl}/>
            <Route path="/stripe-integration" component={ContextControl}/>
            <Route path="/profile" component={Profile}/>
            <Route path="/leads" component={Contacts}/>
            <Route path="/lead/import-export" component={ImportExport}/>
            <Route path="/lists" component={ContactsLists}/>
            <Route path="/tags" component={Tags}/>
            <Route path="/call-details/:fil_cond?" component={ContextControl} />
            <Route path="/campaigns" render={(props) => <OutboundService {...props} type="campaign" />} />
            <Route path="/automations" render={(props) => <OutboundService {...props} type="automation" />} />
            <Route 
                path={["/campaign/new", "/campaign/edit/:formId"]} 
                render={(props) => <OutboundOperations {...props} type="campaign" />} 
            />
            <Route 
                path={["/automation/new", "/automation/edit/:formId"]} 
                render={(props) => <OutboundOperations {...props} type="automation" />} 
            />
            <Route 
                path={["/subscription", "/plan-billing", "/usage"]} 
                render={() => <UsageMain/>} 
            />
            <Route path={["/paymentcallback/:status/:type", "/paymentcallback"]} component={PaymentCallBack}/>
            <Route path="/web-widgets" component={Widgets}/>
            <Route path="/call-widget/:token" component={WidgetProvider}/>
            <Route path="/callvolume" component={CallVolume}/>
            <Route path="/timing-analysis" component={CallDuration}/>
            <Route path="/goal-conversions" component={CallOutcome}/>
            <Route path="/notifications" component={Notifications}/>
            <Route path="/heatmap" component={CallHeatmap}/>
            <Route path="/custom-actions" component={Tools}/>
            <Route path="/custom-fields" component={CustomFields}/>
            <Route path="/profit_report" component={ProfitReport}/>
            <Route exact path="/" render={() => (
                <Redirect to="/login_check"/>
            )}/> 
            <Route path="/login" component={SiteLogin}/>
            <Route path="/forgotpassword" component={ForgotPassword} />
            <Route path="/resetpassword" component={ResetPassword} />
            <Route path="/activate/:activate_code" component={ActivateSignup} />
            <Route path="/invite/:invite_code" component={InviteForm} />
            <Route path="/webhooks" component={Webhooks} />
            <Route path={["/integrations/:type","/integrations"]} component={Integrations} />
            <Route path="/oauth/callback/:param" component={CallBack} />
            <Route path="/payment_history" component={AllSubPaymentHistory}/>
            <Route path="/emailtemplates" component={EmailTemplates}/>
            <Route path="/knowledge" component={KnowledgeBase}/>
            <Route path="/onboarding" component={Onboarding} />
            <Route path="/client/:param" component={Subaccounts}/>
            <Route path="/webhook_logs/:type/:id" component={Logs} />
            <Route path="/ai-prompt-library" component={AIPromptLibrary}/>
            <ToastContainer/>
        </Fragment>
    )
};

export default AppMain;